var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "introduction-culture area"
  }, [_vm._m(0), _c("a-row", {
    attrs: {
      gutter: 24
    }
  }, _vm._l(_vm.cultureList, function (item, index) {
    return _c("a-col", {
      key: index,
      attrs: {
        span: 8
      }
    }, [_c("culture-card", {
      attrs: {
        img: item.img,
        title: item.title,
        paragraph: item.paragraph
      }
    })], 1);
  }), 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "introduction-culture__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("CULTURE")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("企业文化")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };